import { HqApiService } from './hqApiService';
import {
  AddPlacementPayload,
  ProjectCancellation,
} from '../../shared/services/project-service.types';

export class ProjectService {
  constructor(private readonly hqApiService: HqApiService) {}

  public createPlacement = async (body: AddPlacementPayload) => {
    const response = await this.hqApiService.create<void>({
      path: `projects/${body.projectId}/create-placement`,
      body,
    });

    return response;
  };

  public getProjectCancellations = async (workId: string) => {
    const response = await this.hqApiService.get<ProjectCancellation[]>({
      path: `projects/${workId}/cancellations`,
    });

    return response;
  };
}
